import { Fragment } from 'react'
import PropTypes from 'prop-types'
import { useLocation } from 'react-use'

import theme from 'theme'
import useAuth from 'hooks/use-auth'
import { SmallBadge } from 'components/common/Badge'
import { Columns } from 'components/common/Grid'
import Subnav, { SubnavLink } from 'components/navigation/Subnav'
import Content from 'components/common/Content'

const AttacksLayout = ({ hideSubnav, ...props }) => {
  const { companyIsAlfiEnabled } = useAuth()

  const location = useLocation()

  const getAppTabActive = currentPathname =>
    currentPathname.startsWith('/attacks/application') ||
    currentPathname.startsWith('/alfi') ||
    currentPathname.startsWith('/attacks/new/applications')

  const isAppTabActive = getAppTabActive(location.pathname)

  return (
    <Fragment>
      {!hideSubnav && (
        <Subnav>
          <SubnavLink
            data-track-action="open-infrastructure-attacks"
            data-track-category="sub-navigation"
            data-track-on="click"
            getIsLinkActive={currentPathname =>
              currentPathname.startsWith('/attacks') &&
              !currentPathname.startsWith('/attacks/application') &&
              !currentPathname.startsWith('/attacks/scenarios') &&
              !currentPathname.startsWith('/attacks/new/applications')
            }
            text="Infrastructure"
            to="/attacks/infrastructure"
          />
          <SubnavLink
            data-track-action="open-application-attacks"
            data-track-category="sub-navigation"
            data-track-on="click"
            enabled={companyIsAlfiEnabled}
            getIsLinkActive={getAppTabActive}
            text={
              <Columns gap={theme.space[1]}>
                <div>Application</div>
                <SmallBadge
                  backgroundGradient={
                    isAppTabActive
                      ? [theme.colors.green[0], theme.colors.green[0]]
                      : [theme.colors.steel[0], theme.colors.steel[0]]
                  }
                  css={{
                    alignSelf: 'start',
                    pointerEvents: 'none'
                  }}
                >
                  BETA
                </SmallBadge>
              </Columns>
            }
            to="/attacks/application"
          />
          <SubnavLink
            data-track-action="open-scenario-attacks"
            data-track-category="sub-navigation"
            data-track-on="click"
            text="Scenarios"
            to="/attacks/scenarios"
          />
        </Subnav>
      )}
      <Content {...props} />
    </Fragment>
  )
}

AttacksLayout.propTypes = {
  hideSubnav: PropTypes.bool
}

export default AttacksLayout
